import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { useApp } from 'store/steps'
import { DefaultTheme } from 'styled-components'
import { Color } from 'styles/types'

interface TicketItemProps {
    children: React.ReactNode
    date?: string
    quantity?: number
    editedItem?: 'quantity' | 'date' | 'newItem'
    isDisabled?: boolean
    hasSmallerGap?: boolean
    theme?: DefaultTheme
}

const TicketItem = ({
    children,
    date,
    quantity,
    editedItem,
    isDisabled,
    hasSmallerGap,
    theme,
}: TicketItemProps) => {
    const { stepId } = useApp()

    const hasDarkMode = theme?.mode === 'dark'

    let textColor: Color =
        editedItem === 'newItem' && stepId !== 'starter'
            ? 'primary_500'
            : 'grayscale_900'
    let quantityColor: Color =
        editedItem === 'quantity' && stepId !== 'starter'
            ? 'primary_500'
            : 'grayscale_700'
    let dateColor: Color =
        editedItem === 'date' && stepId !== 'starter'
            ? 'primary_500'
            : 'grayscale_900'

    if (isDisabled) {
        textColor = 'grayscale_700'
        quantityColor = 'grayscale_700'
        dateColor = 'grayscale_700'
    }

    if (hasDarkMode) {
        quantityColor = 'grayscale_400'
        textColor = 'grayscale_200'
        dateColor = 'grayscale_200'
    }

    return (
        <Box
            direction={['column', 'row']}
            isFullWidth
            gap={hasSmallerGap ? [8, 24] : [8, 8]}
            justify="space-between"
            align={['flex-start', 'center']}
        >
            <Box gap={8} direction="row" isFullWidth>
                {quantity !== undefined && (
                    <Text variant="bodySmall" color={quantityColor}>
                        {quantity}x
                    </Text>
                )}

                <Text variant="bodySmall" color={textColor} as="div">
                    {children}
                </Text>
            </Box>

            {!!date && (
                <Text variant="bodySmall" color={dateColor} hasNoWrap>
                    {date}
                </Text>
            )}
        </Box>
    )
}

export default TicketItem
